import React from 'react';

import { useAccountActions } from './AccountContext';
import PageSectionTitleWithActions from '../../Shared/UI/PageSectionTitleWithActions/components/PageSectionTitleWithActions';
import Button from '../../Shared/UI/Button/components/Button';
import EditPencilIcon from '../../Shared/UI/EditPencilIcon/components/EditPencilIcon';

const PasswordPageSectionTitle = () => {
  const { openPasswordUpdateModal } = useAccountActions();

  return (
    <PageSectionTitleWithActions
      text="Password"
      actions={
        <Button
          variant="ghost"
          icon={<EditPencilIcon />}
          iconOnly
          aria-label="Edit Password"
          onClick={() => {
            openPasswordUpdateModal();
          }}
        />
      }
    />
  );
};

export default PasswordPageSectionTitle;